import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer6 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Handloom Sarees', path: '/template6/shop' },
        { label: 'Cotton Kurtas', path: '/template6/shop' },
        { label: 'Ethnic Sets', path: '/template6/shop' },
        { label: 'Block Print', path: '/template6/shop' },
        { label: 'Dupattas', path: '/template6/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template6/contact' },
        { label: 'Shipping Policy', path: '/template6/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template6/shipping-exchange' },
        { label: 'FAQs', path: '/template6/faqs' },
        { label: 'Track Order', path: '/template6/orders' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+Display:wght@400;600;700&family=Nunito:wght@300;400;600&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#3B1A08', borderTop: '3px solid #8B4513' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="dharti-footer-main"
                >
                    <div className="dharti-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Noto Serif Display', Georgia, serif",
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#F5F0E8',
                                    letterSpacing: '3px',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                DHARTI
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Nunito', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    color: '#D4C5B0',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                    fontStyle: 'italic',
                                }}
                            >
                                Woven With Heritage, Worn With Pride
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid #6B3410',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#F5F0E8',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#8B4513';
                                            e.currentTarget.style.backgroundColor = 'rgba(139, 69, 19, 0.3)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#6B3410';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                                <a
                                    href="#"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        border: '1px solid #6B3410',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#F5F0E8',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#8B4513';
                                        e.currentTarget.style.backgroundColor = 'rgba(139, 69, 19, 0.3)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#6B3410';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                        <path d="M12 2a10 10 0 1 0 4 19.2" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Noto Serif Display', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    color: '#D4C5B0',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {collectionsLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Nunito', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#F5F0E8',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#D4C5B0')}
                                            onMouseLeave={(e) => (e.target.style.color = '#F5F0E8')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Noto Serif Display', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    color: '#D4C5B0',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Nunito', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#F5F0E8',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#D4C5B0')}
                                            onMouseLeave={(e) => (e.target.style.color = '#F5F0E8')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Noto Serif Display', Georgia, serif",
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    color: '#D4C5B0',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#8B4513', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: '14px', color: '#F5F0E8' }}>
                                        hello@dharti.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#8B4513', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: '14px', color: '#F5F0E8' }}>
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#8B4513', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: '14px', color: '#F5F0E8', lineHeight: 1.6 }}>
                                        Jaipur, Rajasthan, India
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Newsletter Section */}
                <div style={{ backgroundColor: '#2D1406', borderTop: '1px solid #6B3410', borderBottom: '1px solid #6B3410' }}>
                    <div
                        style={{
                            maxWidth: '700px',
                            margin: '0 auto',
                            padding: '48px 24px',
                            textAlign: 'center',
                        }}
                    >
                        <h4
                            style={{
                                fontFamily: "'Noto Serif Display', Georgia, serif",
                                fontSize: '22px',
                                fontWeight: 400,
                                color: '#F5F0E8',
                                letterSpacing: '1px',
                                margin: '0 0 8px 0',
                            }}
                        >
                            Join the Dharti Family
                        </h4>
                        <p
                            style={{
                                fontFamily: "'Nunito', sans-serif",
                                fontSize: '14px',
                                color: '#D4C5B0',
                                margin: '0 0 24px 0',
                            }}
                        >
                            Subscribe for handloom stories, new arrivals, and artisan spotlights.
                        </p>
                        <form
                            onSubmit={handleSubscribe}
                            style={{
                                display: 'flex',
                                gap: '0',
                                maxWidth: '500px',
                                margin: '0 auto',
                            }}
                            className="dharti-newsletter-form"
                        >
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                                style={{
                                    flex: 1,
                                    padding: '14px 20px',
                                    backgroundColor: '#3B1A08',
                                    border: '1px solid #6B3410',
                                    borderRight: 'none',
                                    borderRadius: '2px 0 0 2px',
                                    color: '#F5F0E8',
                                    fontFamily: "'Nunito', sans-serif",
                                    fontSize: '14px',
                                    outline: 'none',
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    padding: '14px 32px',
                                    backgroundColor: '#8B4513',
                                    color: '#FFFFFF',
                                    border: 'none',
                                    borderRadius: '0 2px 2px 0',
                                    fontFamily: "'Nunito', sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease',
                                }}
                                onMouseEnter={(e) => (e.target.style.backgroundColor = '#6B3410')}
                                onMouseLeave={(e) => (e.target.style.backgroundColor = '#8B4513')}
                            >
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '24px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '16px',
                        }}
                        className="dharti-footer-bottom"
                    >
                        <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '12px', color: '#D4C5B0', margin: 0 }}>
                            &copy; 2026 DHARTI. All rights reserved.
                        </p>
                        <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '12px', color: '#D4C5B0', margin: 0, fontStyle: 'italic' }}>
                            Handcrafted with love in India
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="2" fill="#2D1406" stroke="#6B3410" />
                                <text x="18" y="14" textAnchor="middle" fill="#D4C5B0" fontSize="8" fontWeight="bold" fontFamily="Nunito, sans-serif">VISA</text>
                            </svg>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="2" fill="#2D1406" stroke="#6B3410" />
                                <circle cx="15" cy="12" r="5" fill="#D4C5B0" opacity="0.5" />
                                <circle cx="21" cy="12" r="5" fill="#D4C5B0" opacity="0.5" />
                            </svg>
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="2" fill="#2D1406" stroke="#6B3410" />
                                <text x="18" y="14" textAnchor="middle" fill="#D4C5B0" fontSize="7" fontWeight="bold" fontFamily="Nunito, sans-serif">UPI</text>
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .dharti-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .dharti-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 40px;
                        }
                        .dharti-footer-main {
                            padding: 40px 24px !important;
                        }
                        .dharti-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                        .dharti-newsletter-form {
                            flex-direction: column !important;
                        }
                        .dharti-newsletter-form input {
                            border-right: 1px solid #6B3410 !important;
                            border-radius: 2px !important;
                        }
                        .dharti-newsletter-form button {
                            border-radius: 2px !important;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .dharti-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer6;
